// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__etk7b","col":"styles_col__2UYvJ"};